(() => {
  const DEFAULT_FILTERS = [
    'Barrel', 'Basic', 'Biker', 'Bota Campana', 'Boyfriend', 'Cargo', 'Camisa',
    'Enterizo', 'Falda Exclusive', 'Flare', 'Jort', 'Mom Fit', 'Palazzo',
    'Pantalon', 'Short', 'Torero Maxi', 'Wide Leg', 'Bermuda'
  ];

  const handleize = (str) =>
    String(str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const catalogBase = () => {
    const cfg = document.getElementById('chikas-jeans-config');
    if (cfg) {
      try {
        const data = JSON.parse(cfg.textContent || '{}');
        if (data.catalog) return data.catalog;
      } catch (_) {}
    }
    const link = document.querySelector('[data-chikas-nav] a[href*="/collections/"]');
    if (link) return link.getAttribute('href').split('?')[0];
    return '/collections/all';
  };

  const filterList = () => {
    const cfg = document.getElementById('chikas-jeans-config');
    if (cfg) {
      try {
        const data = JSON.parse(cfg.textContent || '{}');
        if (Array.isArray(data.filters) && data.filters.length) return data.filters;
      } catch (_) {}
    }
    return DEFAULT_FILTERS;
  };

  const hoverDesktop = window.matchMedia('(min-width: 1101px) and (hover: hover) and (pointer: fine)');

  const closeAllJeans = (except) => {
    document.querySelectorAll('[data-chikas-jeans].is-open').forEach((el) => {
      if (except && el === except) return;
      el.classList.remove('is-open');
      const t = el.querySelector('[data-chikas-jeans-trigger]');
      const p = el.querySelector('[data-chikas-jeans-panel]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
    });
  };

  const removeLiquidErrors = (nav) => {
    if (!nav) return;
    const walker = document.createTreeWalker(nav, NodeFilter.SHOW_TEXT);
    const bad = [];
    while (walker.nextNode()) {
      const v = walker.currentNode.nodeValue || '';
      if (/chikas-jeans-menu|Liquid error/i.test(v)) bad.push(walker.currentNode);
    }
    bad.forEach((node) => {
      const parent = node.parentElement;
      node.nodeValue = '';
      if (parent && /liquid error/i.test(parent.textContent || '')) {
        parent.remove();
      }
    });
    nav.querySelectorAll('*').forEach((el) => {
      const t = (el.textContent || '').trim();
      if (/Could not find asset snippets\/chikas-jeans-menu/i.test(t)) el.remove();
    });
  };

  const buildJeansMenu = () => {
    const base = catalogBase();
    const filters = filterList().filter((name) => {
      const up = String(name).toUpperCase();
      const h = handleize(name);
      if (!name || up === 'TODOS' || up === 'ALL') return false;
      if (h === 'falda-cargo' || h === 'wide' || up === 'WIDE' || up === 'FALDA CARGO') return false;
      return true;
    });

    const root = document.createElement('div');
    root.className = 'chikas-jeans';
    root.setAttribute('data-chikas-jeans', '');
    root.innerHTML = `
      <button type="button" class="chikas-jeans__trigger" data-chikas-jeans-trigger aria-expanded="false" aria-haspopup="true">
        <span>JEANS</span>
        <svg class="chikas-jeans__caret" width="10" height="10" viewBox="0 0 12 12" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2.5 4.5 L6 8 L9.5 4.5"/></svg>
      </button>
      <div class="chikas-jeans__panel" data-chikas-jeans-panel hidden role="menu" aria-label="Filtros de jeans">
        <p class="chikas-jeans__label">Siluetas</p>
        <ul class="chikas-jeans__list"></ul>
      </div>
    `;
    const list = root.querySelector('.chikas-jeans__list');
    const seen = new Set();
    filters.forEach((name) => {
      const h = handleize(name);
      if (seen.has(h)) return;
      seen.add(h);
      const li = document.createElement('li');
      li.setAttribute('role', 'none');
      const a = document.createElement('a');
      a.className = 'chikas-jeans__item';
      a.setAttribute('role', 'menuitem');
      a.href = `${base}?silhouette=${encodeURIComponent(h)}`;
      a.textContent = String(name).toUpperCase();
      li.appendChild(a);
      list.appendChild(li);
    });
    return root;
  };

  const ensureJeansInNav = () => {
    const nav = document.querySelector('[data-chikas-nav]');
    if (!nav) return;
    removeLiquidErrors(nav);
    if (nav.querySelector('[data-chikas-jeans]')) return;

    const links = Array.from(nav.querySelectorAll(':scope > a'));
    const nuevo = links.find((a) => /nuevo|new/i.test((a.textContent || '').trim()));
    const catalogo = links.find((a) => /cat[aá]logo|catalog/i.test((a.textContent || '').trim()));
    const menu = buildJeansMenu();

    if (nuevo && nuevo.nextSibling) {
      nuevo.parentNode.insertBefore(menu, nuevo.nextSibling);
    } else if (catalogo) {
      catalogo.parentNode.insertBefore(menu, catalogo);
    } else {
      nav.appendChild(menu);
    }
  };

  const boot = () => {
    if (!document.getElementById('chikas-jeans-css-fallback')) {
      const style = document.createElement('style');
      style.id = 'chikas-jeans-css-fallback';
      style.textContent = `
        .chikas-jeans{position:relative;display:inline-flex;align-items:center}
        .chikas-jeans__trigger{appearance:none;border:0;background:transparent;color:#1c1917;font:inherit;font-size:11px;letter-spacing:.12em;text-transform:uppercase;white-space:nowrap;padding:8px 12px;border-radius:999px;cursor:pointer;display:inline-flex;align-items:center;gap:6px}
        .chikas-jeans__trigger:hover,.chikas-jeans.is-open .chikas-jeans__trigger{background:#ffd0d2}
        .chikas-jeans__caret{transition:transform .2s ease}
        .chikas-jeans.is-open .chikas-jeans__caret{transform:rotate(180deg)}
        .chikas-jeans__panel{position:absolute;top:calc(100% + 8px);left:0;z-index:80;min-width:220px;max-width:min(280px,86vw);max-height:min(70vh,420px);overflow-y:auto;padding:14px 10px 12px;background:#fffdfb;border:1px solid rgba(28,25,23,.1);border-radius:14px;box-shadow:0 18px 40px rgba(28,25,23,.14)}
        .chikas-jeans__panel[hidden]{display:none!important}
        .chikas-jeans__label{margin:0 10px 10px;font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:rgba(28,25,23,.45)}
        .chikas-jeans__list{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:2px}
        .chikas-jeans__item{display:block;padding:10px 12px;border-radius:10px;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#1c1917;text-decoration:none}
        .chikas-jeans__item:hover{background:#ffe6e8}
        @media (max-width:1100px){
          .chikas-jeans{display:block;width:100%}
          .chikas-jeans__trigger{width:100%;justify-content:space-between;border-radius:10px}
          .chikas-jeans__panel{position:static;max-width:none;max-height:260px;margin:4px 0 8px;box-shadow:none}
        }
      `;
      document.head.appendChild(style);
    }
    ensureJeansInNav();
    setTimeout(ensureJeansInNav, 400);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('click', (e) => {
    const menuBtn = e.target.closest('[data-chikas-menu]');
    if (menuBtn) {
      const nav = document.querySelector('[data-chikas-nav]');
      if (!nav) return;
      const open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) closeAllJeans();
      return;
    }

    const jeansTrigger = e.target.closest('[data-chikas-jeans-trigger]');
    if (jeansTrigger) {
      e.preventDefault();
      e.stopPropagation();
      const root = jeansTrigger.closest('[data-chikas-jeans]');
      if (!root) return;
      if (hoverDesktop.matches) {
        closeAllJeans();
        return;
      }
      const panel = root.querySelector('[data-chikas-jeans-panel]');
      const willOpen = !root.classList.contains('is-open');
      closeAllJeans(root);
      root.classList.toggle('is-open', willOpen);
      jeansTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (panel) panel.hidden = !willOpen;
      return;
    }

    if (!e.target.closest('[data-chikas-jeans]')) closeAllJeans();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllJeans();
  });
})();
